<template>
    <div class="context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="title">{{viewTitle}}</div>
        </div>
        <div class="form_box">
            <div class="form_item">
                <div class="label">规则：</div>
                <div class="input_box">
                    <div v-for="(item, index) in typeList"
                         :key="index"
                         :class="form.push_day_cycle === item.value?'actived_btn':''"
                         @click="changeType(item.value)"
                         class="btn">
                        {{item.name}}
                    </div>
                </div>
            </div>
            <div class="form_item">
                <div class="label">&nbsp;</div>
                <div class="input_box">
                    <div v-if="form.push_day_cycle === 'DAY'">
                        <span>每隔 </span>
                        <span>
                            <el-input-number v-model="form.days"
                                             class="width_150"
                                             controls-position="right"
                                             :min="0"></el-input-number>
                        </span>
                        <span> 天</span>
                    </div>
                    <div v-if="form.push_day_cycle === 'MONTH'">
                        <el-checkbox-group v-model="form.dayList">
                            <el-checkbox v-for="(item, index) in monthDays"
                                         :label="item"
                                         :key="index"></el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div v-if="form.push_day_cycle === 'WEEK'">
                        <el-checkbox-group v-model="form.dayList">
                            <el-checkbox v-for="(item, index) in weekDays"
                                         :label="item"
                                         :key="index"></el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>
            <div class="form_item">
                <div class="label">推送时间：</div>
                <div class="input_box">
                    <el-time-picker
                            v-model="form.push_time"
                            value-format="HH:mm:ss"
                            placeholder="任意时间点">
                    </el-time-picker>
                </div>
            </div>
            <div class="form_item">
                <div class="label">
                    <el-checkbox @change="changeEndDate"
                                 v-model="showEndDate">截止时间：
                    </el-checkbox>
                </div>
                <div class="input_box">
                    <el-time-picker
                            :disabled="!showEndDate"
                            v-model="form.end_time"
                            value-format="HH:mm:ss"
                            :picker-options="{
                                selectableRange: form.push_time + ' - 23:59:59'
                            }"
                            placeholder="任意时间点">
                    </el-time-picker>
                </div>
            </div>
            <div class="form_item">
                <div class="label">&nbsp;</div>
                <div class="input_box">
                    <el-button type="primary" @click="submit">提交</el-button>
                    <el-button @click="goBack">取消</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'

    export default {
        name: "ruleView",
        data() {
            return {
                viewTitle: '推送规则',
                showEndDate: false,
                form: {
                    push_day_cycle: 'DAY',
                    days: 0,
                    dayList: [],

                    push_time: '',
                    end_time: '',
                },
                typeList: [
                    {name: '按天', value: 'DAY'},
                    {name: '按月', value: 'MONTH'},
                    {name: '按周', value: 'WEEK'},
                ],
                weekDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日',],
                monthDays: [
                    '1','2','3','4','5','6','7','8','9','10',
                    '11','12','13','14','15','16','17','18','19','20',
                    '21','22','23','24','25','26','27','28',
                    '月末'
                ],
            }
        },
        computed: {
            ...mapState('learnData', [
                'ruleData'
            ])
        },
        mounted() {
            if (this.ruleData) {
                this.form.push_day_cycle = this.ruleData.push_day_cycle || 'DAY';
                this.form.push_time = this.ruleData.push_time || '';
                this.form.end_time = this.ruleData.end_time || '';
                if (this.form.push_day_cycle === 'DAY') {
                    this.form.days = this.ruleData.push_per_cycle;
                } else {
                    this.form.dayList = this.ruleData.push_per_cycle.split(',')
                }
            } 
        },
        methods: {
            goBack() {
                this.$emit('changeTopTab', 'tableView')
            },
            changeType(item) {
                this.form.push_day_cycle = item;
                this.form.days = 0;
                this.form.dayList = [];
            },

            changeEndDate() {
                this.form.end_time = ''
            },

            submit() {
                let cycle = '';
                switch (this.form.push_day_cycle) {
                    case 'DAY':
                        cycle = this.form.days;
                        break;
                    case 'MONTH':
                        cycle = this.form.dayList.join(',');
                        break;
                    case 'WEEK':
                        cycle = this.form.dayList.join(',');
                        break;
                }
                let params = {
                    ill_id: this.ruleData.ill_id,
                    item_type: this.ruleData.item_type,
                    push_day_cycle: this.form.push_day_cycle,
                    push_per_cycle: cycle,
                    push_time: this.form.push_time,
                    end_time: this.form.end_time,
                };
                this.httpPost('/push_ill_config', params).then(res => {
                    this.$message.success('配置成功！');
                    this.goBack()
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246,247,248);
    $btn_border: rgb(246,247,248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            /*color: #8d8d8d;*/
            .title {

            }
            .btn_box {
                padding-right: 20px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }

        .form_box {
            box-sizing: border-box;
            width: 100%;
            padding: 10px;
            .form_item {
                line-height: 40px;
                margin-bottom: 15px;
                display: flex;
                .label {
                    flex: 0 0 120px;
                    width: 120px;
                    box-sizing: border-box;
                    font-size: .875rem;
                    color: #606266;
                    text-align: right;
                }
                .input_box {
                    display: flex;
                    box-sizing: border-box;
                    .btn {
                        height: 25px;
                        line-height: 25px;
                        font-size: .875rem;
                        padding: 0 10px;
                        box-sizing: border-box;
                        margin: 7px 10px;
                        cursor: pointer;
                    }
                    .actived_btn {
                        box-sizing: border-box;
                        border: 1px solid #38adff;
                        border-radius: 3px;
                    }
                    .el-checkbox-group {
                        height: 40px !important;
                    }
                }
            }
        }
    }
</style>